'use strict';

module.exports = function (ngModule) {
    ngModule.controller('live', require('./live.ts'));
}


/** WEBPACK FOOTER **
 ** ./src/landing/controllers/index.js
 **/